import { Box, Typography } from '@mui/material';
import style from './CustomOverlapImg.module.css';
import zeplinColor from '../../../theme/Color';

interface CustomOverlapImgProps {
  images: string[];
  name: string[];
  maxVisible?: number; 
}

const CustomOverlapImg = ({ images, name, maxVisible = 4 }: CustomOverlapImgProps) => {
  const totalCount = images?.length || 0;
  const visibleCount = Math.min(totalCount, maxVisible);
  const remainingCount = totalCount - visibleCount;
  
  return (
    <div className={style.avatars}>
      {images?.slice(0, visibleCount).map((val, key) =>
        val ? (
          <span className={style.avatar} key={key}>
            <img src={val} alt='overlap-icon' />
          </span>
        ) : (
          <Box
            key={key}
            sx={{
              borderRadius: '100px',
              padding: '10px',
              width: '32px',
              height: '32px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              backgroundColor:
                zeplinColor[
                  key % 8 === 0
                    ? 'Brand1'
                    : (`USER_PROFILE_COLOR${key % 8}` as keyof typeof zeplinColor)
                ],
            }}
            className={style.avatar}
          >
            <Typography variant='label1' color={zeplinColor.Neutral1}>
              {name[key]
                ?.split(' ')
                .map((value: any, index: number) =>
                  name[key] && (index === 0 || index === name[key]?.split(' ').length - 1)
                    ? value[0].toUpperCase()
                    : '',
                )}
            </Typography>
          </Box>
        ),
      )}
      {remainingCount > 0 && (
        <Box
          sx={{
            borderRadius: '100px',
            padding: '10px',
            width: '32px',
            height: '32px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: zeplinColor.USER_PROFILE_COLOR1,
          }}
          className={style.avatar}
        >
          <Typography variant='label1' color={zeplinColor.Neutral1}>
            +{remainingCount}
          </Typography>
        </Box>
      )}
    </div>
  );
};

export default CustomOverlapImg;
